import { ListReviewAndPublishMode } from './list-review-and-publish-mode';

export interface FeatureFlags {
  isAddFromWorksEnabled?: boolean;
  isDigitisationWorkflowEnabled?: boolean;
  isMisDashboardEnabled?: boolean;
  isMusicScoresDigitisationEnabled?: boolean;
  isReportBrokenLinkEnabled?: boolean;
  reviewWorkflow?: ListReviewAndPublishMode;
  discoverySystemId?: string | null;
  isAutofillProfileEnabled?: boolean;
  isCourseReserveWorkflowEnabled?: boolean;
  isCourseFlowTenancy?: boolean;
  isTalisReaderWorkflowEnabled?: boolean;
  isPersonaPkceLoginEnabled?: boolean;
  requiredItemImportances?: RequiredItemImportanceLevels | null;
  isUnstableResourceTypesEnabled?: boolean;
}

export enum RequiredItemImportanceLevels {
  OFF = 'off',
  WARN = 'warn',
  ENFORCE = 'enforce',
}
